import React from 'react';
import './Tendering.scss'
import { Lists, HeaderSwiper, ColList } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class Tendering extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/Products/tenderbanner.png"), imgHDPath: `${require("img/Products/tenderbanner.png")} 1x,${require("img/Products/tenderbanner@2x.png")} 2x,${require("img/Products/tenderbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '工程建设项目全过程招标、采购代理',
          data: '为工程建设领域各类项目的法人或其他组织提供勘察、设计、监理、施工及重要设备、材料和配套服务采购等建设项目全过程的采购、招标代理服务。',
          imgPath: require("img/Products/tendericon01.png"), imgHDPath: `${require("img/Products/tendericon01.png")} 1x,${require("img/Products/tendericon01@2x.png")} 2x,${require("img/Products/tendericon01@3x.png")} 3x`
        },
        {
          title: '政府采购项目采购代理',
          data: '为各级国家机关、事业单位和团体组织，使用财政性资金进行的货物、工程和服务采购工作，提供全面的政府采购代理服务。通过公开招标、邀请招标、竞争性谈判、竞争性磋商、单一来源采购、询价方式为客户提供政府采购代理服务。',
          imgPath: require("img/Products/tendericon02.png"), imgHDPath: `${require("img/Products/tendericon02.png")} 1x,${require("img/Products/tendericon02@2x.png")} 2x,${require("img/Products/tendericon02@3x.png")} 3x`
        },
        {
          title: '招标采购管理、风险管控咨询',
          data: '对项目采购及招标过程中法律法规的执行情况、流程规范性、合约规划、目标成本管理及风险管控等方面提供监督检查、咨询服务。',
          imgPath: require("img/Products/tendericon03.png"), imgHDPath: `${require("img/Products/tendericon03.png")} 1x,${require("img/Products/tendericon03@2x.png")} 2x,${require("img/Products/tendericon03@3x.png")} 3x`
        }
      ],
      ColIconData: [
        {
          imgPath: require("img/Products/tenderpic01.png"), imgHDPath: `${require("img/Products/tenderpic01.png")} 1x,${require("img/Products/tenderpic01@2x.png")} 2x,${require("img/Products/tenderpic01@3x.png")} 3x`,
          title: '招标代理5A资信认证'
        },
        {
          imgPath: require("img/Products/tenderpic02.png"), imgHDPath: `${require("img/Products/tenderpic02.png")} 1x,${require("img/Products/tenderpic02@2x.png")} 2x,${require("img/Products/tenderpic02@3x.png")} 3x`,
          title: '1000人以上的资信专家库和具备工程、经济、管理、法律等专业的服务团队'
        },
        {
          imgPath: require("img/Products/tenderpic03.png"), imgHDPath: `${require("img/Products/tenderpic03.png")} 1x,${require("img/Products/tenderpic03@2x.png")} 2x,${require("img/Products/tenderpic03@3x.png")} 3x`,
          title: '规范的采购管理流程与内控制作'
        },
        {
          imgPath: require("img/Products/Engicon2.png"), imgHDPath: `${require("img/Products/Engicon2.png")} 1x,${require("img/Products/Engicon2@2x.png")} 2x,${require("img/Products/Engicon2@3x.png")} 3x`,
          title: '全流程电子化招采平台'
        },
        {
          imgPath: require("img/Products/Engicon1.png"), imgHDPath: `${require("img/Products/Engicon1.png")} 1x,${require("img/Products/Engicon1@2x.png")} 2x,${require("img/Products/Engicon1@3x.png")} 3x`,
          title: '央企招采专项检查（审计）经验'
        },
      ],
      caseList: [
        // { imgs: require("img/Products/tendercase01.png"), name: "格力产业园" },
        // { imgs: require("img/Products/tendercase02.png"), name: "安阳万达广场" },
        { imgs: require("img/Products/tendercase03.png"), name: "引黄灌溉调节水库" },
        { imgs: require("img/Products/tendercase04.png"), name: "禹豪铁路" },
        // { imgs: require("img/Products/tendercase05.png"), name: "长沙轨道交通" },
        { imgs: require("img/Products/中央民族大学新校区-min.jpg"), name: "中央民族大学新校区" },
        { imgs: require("img/Products/北京某部队综合楼-min.jpg"), name: "北京某部队综合楼" },
        { imgs: require("img/Products/大连禁毒教育基地-min.jpg"), name: "大连禁毒教育基地" },
        { imgs: require("img/Products/嵩山少林景区-min.jpg"), name: "嵩山少林景区" },
        { imgs: require("img/Products/株洲博物馆美术馆-min.jpg"), name: "株洲博物馆美术馆" },
        { imgs: require("img/Products/武汉军运会场馆-min.jpg"), name: "武汉军运会场馆" },
        { imgs: require("img/Products/武汉车都大厦-min.jpg"), name: "武汉车都大厦" },

      ]
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Tendering">
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          <h5 className="product-title">服务优势</h5>
          <ColList ColIconData={this.state.ColIconData}></ColList>
          <RelatedCases caseList={this.state.caseList} id={'Tendering'}/>
        </div>
      </main>
    )
  }
}
export default Tendering
